export const PATIENTS_BY_EVENTS_FETCH_ERROR =
  'Não conseguimos carregar os dados :(<br/>Por favor, tente novamente!';
